import { render, staticRenderFns } from "./TourGroupInternalPayments.vue?vue&type=template&id=b6fa34f6&scoped=true"
import script from "./TourGroupInternalPayments.vue?vue&type=script&lang=js"
export * from "./TourGroupInternalPayments.vue?vue&type=script&lang=js"
import style0 from "./TourGroupInternalPayments.vue?vue&type=style&index=0&id=b6fa34f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fa34f6",
  null
  
)

export default component.exports